const FaqIcon = ({ className = "", style = {} }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="512"
            height="512"
            viewBox="0 0 682.667 682.667"
            className={className}
            style={style}
            fill="none"
            stroke="currentColor"
            strokeWidth="22"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g transform="matrix(1.33333 0 0 -1.33333 0 682.667)">

                <path d="M7.5 190.64v83.81c0 42.02 34.07 76.09 76.09 76.09h70.77" />

                <path d="M357.64 192.18v-16.54c0-42.02-34.069-76.09-76.09-76.09h-99.479l-47.611-54.41c-14.13-16.14-40.71-6.15-40.71 15.3v39.11h-10.16c-36.91 0-67.689 26.29-74.62 61.17" />

                <path d="M443.33 473.37c34.88-6.93 61.17-37.71 61.17-74.62v-98.81c0-42.02-34.07-76.09-76.09-76.09h-10.16v-39.12c0-21.44-26.58-31.43-40.71-15.29l-47.61 54.41h-99.48c-42.02 0-76.09 34.07-76.09 76.09v98.81c0 42.02 34.07 76.09 76.09 76.09h182.96" />

                <path d="M147.478 189.886v-.472" />
                <path d="M183.637 189.886v-.472" />
                <path d="M217.663 189.886v-.472" />

                <path d="M289.583 374.401c0 1.886.131 3.741.384 5.558 2.741 19.639 19.797 34.693 40.284 34.28 20.726-.417 37.895-17.016 38.97-37.718 1.19-22.941-17.082-41.966-39.792-41.966v-22.808" />

                <path d="M329.429 282.38v-.471" />

            </g>
        </svg>
    );
};

export default FaqIcon;
